import React from 'react';
import styled, { css } from 'styled-components';

import useTranslation from 'src/hooks/use-translation';
import CheckmarkSVG from 'src/assets/checkmark';
import { DutchiePayHeader, DutchiePayTextBody } from 'src/payments/components';
import { OrderHeaderCard } from '../base/order-header';

export function PaymentCompleteHeader(): JSX.Element {
  const { t } = useTranslation();
  const icon = (
    <Circle>
      <CheckmarkSVG height={15} width={15} />
    </Circle>
  );

  return (
    <OrderHeaderCard
      icon={icon}
      body={
        <>
          <DutchiePayHeaderGreen data-testid='payment-complete'>
            {t('dutchie.in-store.order-header.payment-complete', 'Payment Successful')}
          </DutchiePayHeaderGreen>

          <DutchiePayTextBodyWithoutMargin>
            {t('dutchie.in-store.order-header.thank-you', 'Thank you for shopping with us.')}
          </DutchiePayTextBodyWithoutMargin>
        </>
      }
    />
  );
}

const Circle = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  place-content: center;
  place-items: center;
  background: white;
  border: 2px solid #00a47c;
  border-radius: 50%;
  margin-right: 10px;
`;

const DutchiePayHeaderGreen = styled(DutchiePayHeader)`
  ${({ theme: { colors } }) => css`
    color: ${colors.dutchiePayGreen};
  `}
`;

// FIXME: Remove me when margin on DutchiePayTextBody is removed
const DutchiePayTextBodyWithoutMargin = styled(DutchiePayTextBody)`
  margin: 0;
`;
